import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'

const gridFiltersConfig: any = {
    STICHTAG: { prop: null, param: 'STICHTAG', url_param: false },
}

const initialState = {
    loadUmlListStatus: 'idle',
    loadUmlListError: undefined as any,
    loadUmlListLastArgs: undefined as any,
    loadUmlStatus: 'idle',
    loadUmlError: undefined as any,
    saveUmlStatus: 'idle',
    saveUmlError: undefined as any,
    deleteUmlStatus: 'idle',
    deleteUmlError: undefined as any,
    StammIni_AnzeigeFeldReferenzUmlageStatus: 'idle',
    StammIni_AnzeigeFeldReferenzUmlageError: undefined as any,

    umlList: [] as any[],
    actSumMap: {} as any,
    AnzeigeFeldReferenzUmlage: undefined as any,
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadUmlList = createAsyncThunk('umlSlice/loadUmlList', async ({ gridFilters, globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().umlSlice.loadUmlListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/uml/`, globalFilters, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUmlListStatus } = getState().umlSlice
        return loadUmlListStatus !== 'pending'
    }
})

export const loadUml = createAsyncThunk('umlSlice/loadUml', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/uml/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUmlStatus } = getState().umlSlice
        return loadUmlStatus !== 'pending'
    }
})

export const saveUml = createAsyncThunk('umlSlice/saveUml', async ({ uml }: any, { rejectWithValue }: any) => {
    let promises = []
    if (uml?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/uml/${ uml?.HDR_ID }/`,
            prepareData(uml),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/uml/`,
            prepareData(uml),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveUmlStatus } = getState().umlSlice
        return saveUmlStatus !== 'pending'
    }
})

export const deleteUml = createAsyncThunk('umlSlice/deleteUml', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/uml/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteUmlStatus } = getState().umlSlice
        return deleteUmlStatus !== 'pending'
    }
})

export const StammIni_AnzeigeFeldReferenzUmlage = createAsyncThunk('umlSlice/StammIni_AnzeigeFeldReferenzUmlage', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_AnzeigeFeldReferenzUmlage/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { StammIni_AnzeigeFeldReferenzUmlageStatus } = getState().umlSlice
        return StammIni_AnzeigeFeldReferenzUmlageStatus !== 'pending'
    }
})

export const fetchActSum = createAsyncThunk('umlSlice/fetchActSum', async ({ uml, gridFilters, forceReload }: any, { rejectWithValue, signal }: any) => {
    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/flguv/?action=LTE&obj=${uml.OBJNR}&sno=${uml.NO}&min_dat=${gridFilters.values.STICHTAG}&max_dat=1900-01-01`, undefined, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
                signal,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { fetchActSumStatus } = getState().umlSlice
        return fetchActSumStatus !== 'pending'
    }
})

const UmlSlice = createSlice({
    name: 'umlSlice',
    initialState,
    reducers: {
        resetloadUmlListError: (state) => {
            state.loadUmlListError = undefined
        },
        resetloadUml: (state) => {
            state.formItem = undefined
            state.loadUmlError = undefined
        },
        resetloadUmlError: (state) => {
            state.loadUmlError = undefined
        },
        resetsaveUml: (state) => {
            state.formItem = undefined
            state.saveUmlError = undefined
        },
        resetsaveUmlError: (state) => {
            state.saveUmlError = undefined
        },
        resetdeleteUmlError: (state) => {
            state.deleteUmlError = undefined
        },
        resetStammIni_AnzeigeFeldReferenzUmlage: (state) => {
            state.AnzeigeFeldReferenzUmlage = undefined
            state.StammIni_AnzeigeFeldReferenzUmlageError = undefined
        },
        resetStammIni_AnzeigeFeldReferenzUmlageError: (state) => {
            state.StammIni_AnzeigeFeldReferenzUmlageError = undefined
        },
        resetfetchActSumError: (state, action) => {
            state.actSumMap[action.payload.uml.HDR_ID].error = undefined
        },
        removeFromUmlListById: (state, action) => {
            state.umlList = state.umlList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromUmlListByIds: (state, action) => {
            state.umlList = state.umlList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.umlList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadUmlListStatus = 'preloaded'
            state.loadUmlListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.umlList = []
            state.loadUmlListStatus = 'idle'
            state.loadUmlListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadUmlList.pending, (state) => {
            state.loadUmlListStatus = 'pending'
            state.loadUmlListError = undefined
        })
        builder.addCase(loadUmlList.fulfilled, (state, action) => {
            state.loadUmlListStatus = 'idle'

            if (!action.payload) { return }

            state.loadUmlListLastArgs = action.payload.args

            {
                state.umlList = action.payload.data

            }
        })
        builder.addCase(loadUmlList.rejected, (state, action) => {
            state.loadUmlListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUmlListError = action.error.message
            } else {
                state.loadUmlListError = action.payload
            }
        })

        builder.addCase(loadUml.pending, (state) => {
            state.loadUmlStatus = 'pending'
            state.loadUmlError = undefined
        })
        builder.addCase(loadUml.fulfilled, (state, action) => {
            state.loadUmlStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.umlList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.umlList.push(newItem) }
                else { state.umlList[i] = { ...state.umlList[i], ...newItem } }
            }
        })
        builder.addCase(loadUml.rejected, (state, action) => {
            state.loadUmlStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUmlError = action.error.message
            } else {
                state.loadUmlError = action.payload
            }
        })

        builder.addCase(saveUml.pending, (state) => {
            state.saveUmlStatus = 'pending'
            state.saveUmlError = undefined
        })
        builder.addCase(saveUml.fulfilled, (state, action) => {
            state.saveUmlStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.umlList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.umlList.push(newItem) }
                else { state.umlList[i] = { ...state.umlList[i], ...newItem } }
            }
        })
        builder.addCase(saveUml.rejected, (state, action) => {
            state.saveUmlStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveUmlError = action.error.message
            } else {
                state.saveUmlError = action.payload
            }
        })

        builder.addCase(deleteUml.pending, (state) => {
            state.deleteUmlStatus = 'pending'
            state.deleteUmlError = undefined
        })
        builder.addCase(deleteUml.fulfilled, (state, action) => {
            state.deleteUmlStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.umlList = state.umlList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.umlList = state.umlList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteUml.rejected, (state, action) => {
            state.deleteUmlStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteUmlError = action.error.message
            } else {
                state.deleteUmlError = action.payload
            }
        })

        builder.addCase(StammIni_AnzeigeFeldReferenzUmlage.pending, (state) => {
            state.StammIni_AnzeigeFeldReferenzUmlageStatus = 'pending'
            state.StammIni_AnzeigeFeldReferenzUmlageError = undefined
        })
        builder.addCase(StammIni_AnzeigeFeldReferenzUmlage.fulfilled, (state, action) => {
            state.StammIni_AnzeigeFeldReferenzUmlageStatus = 'idle'

            {
                state.AnzeigeFeldReferenzUmlage = action.payload

            }
        })
        builder.addCase(StammIni_AnzeigeFeldReferenzUmlage.rejected, (state, action) => {
            state.StammIni_AnzeigeFeldReferenzUmlageStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.StammIni_AnzeigeFeldReferenzUmlageError = action.error.message
            } else {
                state.StammIni_AnzeigeFeldReferenzUmlageError = action.payload
            }
        })

        builder.addCase(fetchActSum.pending, (state, action) => {
            const { uml } = action.meta.arg
            state.actSumMap[uml.HDR_ID] = { status: 'pending', error: undefined, data: null }
        })
        builder.addCase(fetchActSum.fulfilled, (state, action) => {
            const { uml } = action.meta.arg
            state.actSumMap[uml.HDR_ID] = {
                status: 'idle',
                error: undefined,
                data: action.payload.data,
            }
        })
        builder.addCase(fetchActSum.rejected, (state, action) => {
            const { uml } = action.meta.arg
            state.actSumMap[uml.HDR_ID] = { status: 'error', error: action.error.message === 'Rejected' ? action.payload : action.error.message, data: null }
        })

    }
})

export const {
    resetloadUmlListError,
    resetloadUml,
    resetloadUmlError,
    resetsaveUml,
    resetsaveUmlError,
    resetdeleteUmlError,
    resetStammIni_AnzeigeFeldReferenzUmlage,
    resetStammIni_AnzeigeFeldReferenzUmlageError,
    resetfetchActSumError,
    removeFromUmlListById,
    removeFromUmlListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = UmlSlice.actions
export default UmlSlice.reducer
